import React from 'react';
import { Tabs, Typography } from 'antd';

import NodeFetchAccounts from './node/fetch-accounts';
import GoFetchAccounts from './golang/fetch-accounts';
import NodeFetchTransactions from './node/fetch-transactions';
import NodeCreateTransaction from './node/create-transaction';
import NodeFetchBatches from './node/fetch-batches';
import NodeFetchBatchDetails from './node/fetch-batch-details';
import NodeCreateBatch from './node/create-batch';
import './index.scss';

const { Title } = Typography;

const ExamplesIndex = () => (
  <>
    <Title level={3}>List accounts</Title>
    <Tabs defaultActiveKey="node">
      <Tabs.TabPane tab="Node" key="node">
        <NodeFetchAccounts />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Go" key="go">
        <GoFetchAccounts />
      </Tabs.TabPane>
    </Tabs>
    <Title level={3}>List transactions</Title>
    <Tabs defaultActiveKey="node">
      <Tabs.TabPane tab="Node" key="node">
        <NodeFetchTransactions />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Go" key="go" />
    </Tabs>
    <Title level={3}>Create transaction</Title>
    <Tabs defaultActiveKey="node">
      <Tabs.TabPane tab="Node" key="node">
        <NodeCreateTransaction />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Go" key="go" />
    </Tabs>
    <Title level={3}>List batches</Title>
    <Tabs defaultActiveKey="node">
      <Tabs.TabPane tab="Node" key="node">
        <NodeFetchBatches />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Go" key="go" />
    </Tabs>
    <Title level={3}>Retrieve batch details</Title>
    <Tabs defaultActiveKey="node">
      <Tabs.TabPane tab="Node" key="node">
        <NodeFetchBatchDetails />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Go" key="go" />
    </Tabs>
    <Title level={3}>Create batch</Title>
    <Tabs defaultActiveKey="node">
      <Tabs.TabPane tab="Node" key="node">
        <NodeCreateBatch />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Go" key="go" />
    </Tabs>
  </>
);

export default ExamplesIndex;
